__turbopack_context__.v({
  "divider": "Footer-module-scss-module__-TkEBW__divider",
  "extraWide": "Footer-module-scss-module__-TkEBW__extraWide",
  "footerHeader": "Footer-module-scss-module__-TkEBW__footerHeader",
  "footerSection": "Footer-module-scss-module__-TkEBW__footerSection",
  "innerContent": "Footer-module-scss-module__-TkEBW__innerContent",
  "mainContainer": "Footer-module-scss-module__-TkEBW__mainContainer",
  "mainContent": "Footer-module-scss-module__-TkEBW__mainContent",
});
